import React from "react"
import "./style.css"


export default function Footer(){
  return (
      <section className="footer-section"   data-scroll-section id="contacts">
        <div>
        <a href="mailto:mhlungusk@gmail.com">mhlungusk@gmail.com</a>
        </div>
        <div className="social-links">
          <li><a href="https://github.com/SfundoMhlungu"><img src="/assets/images/github.png"></img></a></li>
          <li><a href="https://twitter.com/MhlunguSfundo"><img src="/assets/images/twitter.png"></img></a></li>
          <li><a href="https://www.linkedin.com/in/sfundo-mhlungu-331588168"><img src="/assets/images/linkedin.png"></img></a></li>
         
        </div>
      </section>
  )
}